import { marked } from "marked";
import TurndownService from "turndown";

marked.setOptions({ gfm: true, breaks: false });

const turndown = new TurndownService({
  headingStyle: "atx",
  codeBlockStyle: "fenced",
  bulletListMarker: "-",
});

/** HTML → Markdown（编辑视图）；空串原样返回 */
export function htmlToMarkdown(html: string): string {
  const source = html ?? "";
  if (!source.trim()) return "";
  return turndown.turndown(source).trim();
}

/** Markdown → HTML（落库）；空串原样返回 */
export function markdownToHtml(markdown: string): string {
  const source = markdown ?? "";
  if (!source.trim()) return "";
  const rendered = marked.parse(source, { async: false });
  return typeof rendered === "string" ? rendered.trim() : "";
}
